<template>
    <div class="nodata">
        <div>
            <img
                :src="[
                    theme === 'white'
                        ? require('@/assets/images/builderPage/nodata.png')
                        : require('@/assets/images/builderPage/nodata_black.png'),
                ]"
                alt=""
            />
            <p>{{ $t('text02') }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NoData',
    props: {
        theme: {
            type: String,
            default: 'white'
        }
    }
}
</script>

<style lang="less" scoped>
@import url('../css/mixins.less');

.nodata {
    position: absolute;
    top: 50%;
    left: 50%;
    text-align: center;
    transform: translate(-50%, -50%);

    p {
        color: #999;
        font-size: 14px;
        // #font_theme();
    }
    
    img {
        width: 100px; // Added default width just in case, based on typical usage
        margin-bottom: 10px;
    }
}
</style>
